import * as actionTypes from './actionTypes';
import * as actions from './actions';
import reducer from './reducer';

export default reducer;
export { actionTypes, actions };
